import { Injectable } from '@angular/core';
import { ApiProvider } from '../api/api';


@Injectable()
export class ItemProvider {

  constructor(private api:ApiProvider) {
  }
  async details(isbn: string):Promise <BibItem> {
    const query = `{
      getBookDetails(isbn:"${isbn}"){
        id
        ids { type id }
        title
        author
        authors
        publisher
        publishYear
        pageCount
        averageRating
        ratingsCount
        readingModes { text image }
        available
        format
        language
        previewLink
        imageLinks { type url }
        isbns
        upcs
        subjects
        summaries { text source }
        series
        notes
      }
    }`;
    let details = await this.api.query(query);
    if (details && details.getBookDetails){
      return details.getBookDetails;
    } else {
      return null;
    }
  };

}
export interface BibIdentifier{
  type: string;
  id: string;
}
export interface BibReadingModes{
  text: boolean;
  image: boolean;
}
export interface BibImage{
  type: string;
  url: string;
}
export interface BibSummary{
  text: string;
  source: string;
}
export interface Item{
  id?: number;
  checkoutOk?: boolean,
  statusText?: string,
  statusCode?: string,
  bibIds?: Array<string>,
  barcode?: string,
  dueDate?: string,
  location ?: any,
  bib?: BibItem
}
export interface BibItem{
  id?: number;
  ids?: Array<BibIdentifier>;
  title?: string;
  author?: string;
  authors?: Array<string>;
  publisher?: string;
  publishYear?: number;
  pageCount?: number;
  averageRating?: number;
  ratingsCount?: number;
  readingModes?: BibReadingModes;
  available?: boolean;
  format?: string;
  language?: string;
  previewLink?: string;
  imageLinks?: Array<BibImage>;
  isbns?:Array<string>;
  upcs?:Array<string>;
  subjects?:Array<string>;
  summaries?: Array<BibSummary>;
  series?:Array<string>;
  notes?:Array<string>;
  barcode?: string;
  displayState?: number;
  bookPassed?: any;
  bibids?: Array<string>;
  isbnObj?: any;
  responseInfo?: any;
  returnDate?: string;
  src?: string;
  source?: string;
  reviews?: any;
}


// WEBPACK FOOTER //
// ./src/providers/item/item.ts